import { GridCellProps } from '@progress/kendo-react-grid';
import { useCallback, useMemo } from 'react';
import useViewCheckbook from 'src/hooks/useViewCheckbook';
import GridCellBase from '../GridCellBase';
import ExpandCollapseCell from './ExpandCollapseCell';

const PlannedAmountDetailColumnCell = (props: GridCellProps) => {
  const { expanded = false } = props.dataItem;
  const { dataItem } = props;
  const { setHoldAmountData } = useViewCheckbook();
  const handleExpendClick = useCallback(() => {
    setHoldAmountData((pre) =>
      pre.map((transaction) => ({
        ...transaction,
        expanded: transaction.rowId === dataItem.rowId ? !dataItem.expanded : transaction.expanded,
      }))
    );
  }, [dataItem.expanded, dataItem.rowId, setHoldAmountData]);
  const lastRow = useMemo(() => dataItem.rowId === 'noExpand', [dataItem.rowId]);

  return (
    <GridCellBase {...props} className="k-hierarchy-cell" disableToolTip>
      {!lastRow && (
        <ExpandCollapseCell
          title="Expand/Collapse"
          expand={expanded}
          onExpand={handleExpendClick}
          plusIconColor="#0e80b4"
          minusIconColor="#0e80b4"
        />
      )}
    </GridCellBase>
  );
};

export default PlannedAmountDetailColumnCell;
